<template>
  <div ref="routerTabsRef" class="router-tabs">
    <div class="refresh" @click="handleRefresh">
      <img class="icon-refresh" :src="iconRefresh" />
    </div>
    <!--  -->
    <div ref="routerTabsMainRef" class="router-tabs-main">
      <div class="router-bg left-bg"></div>
      <ul ref="routerTabsListRef" class="list">
        <li
          v-for="(item, key) in browsingHistoryList"
          class="item"
          :class="{ active: $route.name == key }"
        >
          <span @click="handleClickRouter(key, item)">{{ item.title }}</span>
          <img
            class="icon-close"
            :src="$route.name == key ? iconCloseActive : iconClose"
            @click="handleClose(key, item)"
          />
        </li>
        <li class="default-item">430zt-afterclass-admin</li>
      </ul>
      <div v-show="showRightBG" class="right-bg"></div>
    </div>
    <!-- <div class="router-bg right-bg"></div> -->
    <div class="more">
      <Dropdown placement="top-end">
        <img :src="iconMore" />
        <DropdownMenu slot="list">
          <DropdownItem
            ><p @click="handleMore(1)">关闭当前标签</p></DropdownItem
          >
          <DropdownItem
            ><p @click="handleMore(2)">关闭其他标签</p></DropdownItem
          >
          <DropdownItem
            ><p @click="handleMore(3)">关闭所有标签</p></DropdownItem
          >
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
export default {
  data() {
    return {
      iconClose: require('@/assets/img/icon/icon_close.png'),
      iconCloseActive: require('@/assets/img/icon/icon_close_active.png'),
      iconRefresh: require('@/assets/img/icon/icon_refresh@2x.png'),
      portOrg: localStorage.getItem('portOrg'),
      iconMore: require('@/assets/img/icon/icon_coperation@2x.png'),
      showRightBG: false

    };
  },
  computed: {
    ...mapGetters(['browsingHistoryList']),
    ...mapState(['userInfo'])

  },
  watch: {
    $route: {
      handler: function (to, from) {
        if (this.$refs.routerTabsRef) {
          this.handlerTabScrollLeft();
        }
      },
      immediate: true
    }
  },
  created() {

  },
  mounted() {
    this.$nextTick(() => {
      this.handlerTabScrollLeft();
    });
  },
  methods: {
    ...mapMutations([
      'CLOSE_BROWSINGHISTORYLIST'
    ]),
    ...mapActions(['setIfRouterAlive']),
    handlerTabScrollLeft() {
      const mainDom = this.$refs.routerTabsMainRef;
      const domOffsetWidth = this.$refs.routerTabsRef.offsetWidth;
      let itemAllWidth = 0;
      const mainDomSLeft = mainDom.scrollLeft;
      this.$nextTick(() => {
        try {
          const activeOffsetLeft = mainDom.querySelector('.active').offsetLeft;
          console.log('activeOffsetLeft', activeOffsetLeft, mainDomSLeft, domOffsetWidth);
          // 目标tab在滚滚动条之前
          if (activeOffsetLeft < mainDomSLeft) {
            mainDom.scrollLeft = mainDomSLeft - activeOffsetLeft - 500;
          } else if (activeOffsetLeft > mainDomSLeft + domOffsetWidth - 200) {
            // 目标在 滚动条之后
            mainDom.scrollLeft = activeOffsetLeft - domOffsetWidth + 360;
          }
          const itemDoms = mainDom.querySelectorAll('.item');
          for (let i = 0, len = itemDoms.length; i < len; i++) {
            itemAllWidth += itemDoms[i].offsetWidth;
          }
          if (mainDom.offsetWidth < itemAllWidth) {
            this.showRightBG = true;
          } else {
            this.showRightBG = false;
          }
        } catch (err) {
          console.log(err);
        }
      });
    },
    handleClickRouter(key, item) {
      if (this.$route.name == key) {
        return null;
      }
      const query = !item['query'] ? {} : item.query;
      const routeName = this.$route.name; const activeNames = ['financeCenter_settlement_org_details', 'financeCenter_settlement_sch_details'];
      // this.$router.push({ name: item.routerName, params: item.params, query: Object.assign({ routerDate: new Date().getTime() }, query) })
      this.$router.push({ name: item.routerName, params: item.params, query: Object.assign({}, query) });
      if (activeNames.includes(routeName) && activeNames.includes(item.routerName)) {
        this.setIfRouterAlive(false);
        setTimeout(() => {
          this.setIfRouterAlive(true);
        }, 0);
      }
    },
    // 关闭route tab
    handleClose(key, item) {
      if (this.$route.name == key) {
        const keys = Object.keys(this.browsingHistoryList);

        if (keys.length === 1) {
          const title = this.browsingHistoryList[keys]['title'];
          if (['数据概览', '数据看板'].includes(title)) {
            return null;
          }
          this.judgeRouterPush(this.portOrg, this.userInfo.orgId);
        } else {
          const index = keys.findIndex(i => { return i === key; });
          console.log(index, 'index')
          if (index == 0) {
            this.handleClickRouter(keys[index + 1], this.browsingHistoryList[keys[index + 1]]);
          } else {
            this.handleClickRouter(keys[index - 1], this.browsingHistoryList[keys[index - 1]]);
          }

        }
      }
      this.CLOSE_BROWSINGHISTORYLIST(key);
    },
    // 判断要跳转到哪个首页
    judgeRouterPush(portOrg, orgId = '') {
      switch (portOrg) {
        case '0':
          // 平台
          this.$router.push({ name: 'operationIndex' });
          break;
        case '1':
          // 教育局
          if (orgId === '614867004922269697') {
            // this.$router.push({ name: 'mainCenter_education_educationShowEduData' });

            this.$router.push({ name: 'dataStatistics_dataStatistics' });
          } else {
            this.$router.push({ name: 'mainCenter_education_educationIndex' });
          }

          break;
        case '2':
          // 学校
          this.$router.push({ name: 'schoolIndex' });
          break;
        case '3':
          // 服务
          this.$router.push({ name: 'serviceIndex' });
          break;
        default:
          break;
      }
    },
    // 更多操作
    handleMore(val) {
      const keys = Object.keys(this.browsingHistoryList);
      switch (val) {
        case 1:
          this.handleClose(this.$route.name);
          break;
        case 2:
          keys.forEach(key => {
            if (key != this.$route.name) {
              this.CLOSE_BROWSINGHISTORYLIST(key);
            }
          });
          break;
        case 3:
          keys.forEach(key => {
            this.CLOSE_BROWSINGHISTORYLIST(key);
          });
          this.judgeRouterPush(this.portOrg, this.userInfo.orgId);
          break;
      }
    },
    // 刷新页面
    handleRefresh() {
      location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.router-tabs {
  background-color: #ffffff;
  position: relative;
  display: flex;
  justify-content: space-between;
  .router-tabs-main::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
  }
  .router-tabs-main {
    -ms-overflow-style: none;
  }
  .router-tabs-main {
    overflow: -moz-scrollbars-none;
  }
  .router-tabs-main {
    width: 97%;
    /* overflow: hidden; */
    overflow-x: scroll;
    /* position: relative; */
    .router-bg {
      position: absolute;
      width: 16px;
      height: 42px;

      background: linear-gradient(
        270deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(0, 0, 0, 0.15) 100%
      );
    }
  }
  .list {
    display: flex;
    position: relative;
    .item {
      flex: 0 0 auto;
      border-right: 1px solid #eff0f8;
      height: 42px;
      line-height: 42px;
      font-size: 12px;
      background-color: #fff;
      color: #606266;
      padding: 0 10px;
      border-bottom: 0px;
      cursor: pointer;
      font-size: 13px;
      &.active {
        color: #000000;
        background: #eff0f8;
      }
      .icon-close {
        width: 12px;
        height: 12px;
        margin-left: 12px;
      }
    }
    .default-item {
      opacity: 0;
    }
  }

  .left-bg {
    left: 56px;
    top: 0;
    z-index: 10;
  }
  .right-bg {
    right: 38px;
    top: 0;
    background-color: #fff !important;
    position: absolute;
    width: 16px;
    height: 42px;
    display: none;
  }
  .more {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    cursor: pointer;
    background: #fff;
    z-index: 100;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .refresh {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 40px;
    cursor: pointer;
    .icon-refresh {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
